// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles/themes.css */
.theme-light {
    --background-color: #ffffff;
    --text-color: #000000;
    --header-color: #f0f0f0;
  }
  
  .theme-dark {
    --background-color: #1e1e1e;
    --text-color: #ffffff;
    --header-color: #333333;
  }
  
  .base-layout {
    background-color: var(--background-color);
    color: var(--text-color);
    display: flex;
    height: 100vh;
  }
  
  .base-layout-header {
    background-color: var(--header-color);
    padding: 1rem;
  }
  
  .base-layout-left-sidebar,
  .base-layout-right-sidebar {
    width: 20%;
    background-color: var(--header-color);
    padding: 1rem;
  }
  
  .base-layout-content-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  `, "",{"version":3,"sources":["webpack://./src/context/styles/themes.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,wBAAwB;IACxB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;;IAEE,UAAU;IACV,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB","sourcesContent":["/* styles/themes.css */\n.theme-light {\n    --background-color: #ffffff;\n    --text-color: #000000;\n    --header-color: #f0f0f0;\n  }\n  \n  .theme-dark {\n    --background-color: #1e1e1e;\n    --text-color: #ffffff;\n    --header-color: #333333;\n  }\n  \n  .base-layout {\n    background-color: var(--background-color);\n    color: var(--text-color);\n    display: flex;\n    height: 100vh;\n  }\n  \n  .base-layout-header {\n    background-color: var(--header-color);\n    padding: 1rem;\n  }\n  \n  .base-layout-left-sidebar,\n  .base-layout-right-sidebar {\n    width: 20%;\n    background-color: var(--header-color);\n    padding: 1rem;\n  }\n  \n  .base-layout-content-container {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
